<div class="thank-you-container">
    <img src="assets/study-bru-mascot.png" alt="Email Confirmation" width="200" />
    <h2>Thank You for Signing Up!</h2>
    <p>Please check your email ({{ userEmail }}) for a confirmation link.</p>
    <!-- <p>Once you've confirmed, come back and <a routerLink="/login">log in</a>.</p> -->
</div>
